import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMicroscope = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M13 0H9v2H8a5 5 0 0 0-5 5v3.17A3.001 3.001 0 1 0 6.83 14H14v-2H6.83A3 3 0 0 0 5 10.17V7a3 3 0 0 1 3-3v6h6V2h-1zM5 13a1 1 0 1 1-2 0 1 1 0 0 1 2 0",
		clipRule: "evenodd"
	})
});
export default SvgMicroscope;
